import { createSlice } from "@reduxjs/toolkit";
import { AdminState } from "../types";

const initialState: AdminState = {
  availableEvents: {
    content: [],
    currentPage: 1,
    size: 10,
    total: 0,
    totalPages: 0,
  },
  token: "",
  currentId: "",
  filters: {
    name: "",
    zip: "",
    place: "",
    type: "",
    period: { from: "", to: "" },
    speaker: "",
    city: "",
    searchKeywords: "",
  },
  loading: false,
  viewOnlyArchived: false,
  firstName: "",
  lastName: "",
  role: "",
};

export const adminSlice = createSlice({
  name: "adminState",
  initialState,
  reducers: {
    getEventSuccess(state: AdminState) {
      state.loading = false;
    },
    getAllEventsSuccess(state: AdminState, action: any) {
      state.availableEvents = action.payload;
      state.loading = false;
    },
    getAllEventsError(state: AdminState) {
      state.availableEvents = {
        content: [],
        currentPage: 1,
        size: 10,
        total: 0,
        totalPages: 0,
      };
      state.loading = false;
    },
    setEvents(state: AdminState, action: any) {
      state.availableEvents.content = action.payload;
    },
    setFilterValues(state: AdminState, action: any) {
      state.filters = action.payload;
    },
    setPlace(state: AdminState, action: any) {
      state.filters.place = action.payload;
    },
    setSpeaker(state: AdminState, action: any) {
      state.filters.speaker = action.payload;
    },
    setCurrentId(state: AdminState, action: any) {
      state.currentId = action.payload;
    },
    loginStart(state: AdminState) {
      state.loading = true;
    },
    loginSuccess(state: AdminState, action: any) {
      state.loading = false;
      state.token = action.payload;
    },
    loginError(state: AdminState) {
      state.loading = false;
    },
    stopLoading(state: AdminState) {
      state.loading = false;
    },
    getUserDetailsSuccess(state: AdminState, action: any) {
      state.loading = false;
      state.firstName = action.payload.vorname;
      state.lastName = action.payload.nachname;
      state.role = action.payload.rolle;
    },
    getUserDetailsError(state: AdminState) {
      state.loading = false;
    },
    viewArchivedToggle(state: AdminState) {
      state.viewOnlyArchived = !state.viewOnlyArchived;
    },
    reset() {
      return { ...initialState };
    },
  },
});

const { reducer } = adminSlice;

export default reducer;
